import { render, staticRenderFns } from "./CurrencyAmountField.vue?vue&type=template&id=4d7706d2"
import script from "./CurrencyAmountField.vue?vue&type=script&lang=ts"
export * from "./CurrencyAmountField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports